import GameStepBase, {createGameFlowCancelResponse} from './game_step_base';
import _ from '../../../utils/underscore';
import RestrictionMessages from "../../restrictions/messages/restriction_messages";

export default class RestrictionsGameStep extends GameStepBase {
    static CLASS = 'RestrictionsGameStep';

    init(params) {
        super.init(params);
        if(_.isNullOrUndefined(params.isReal)) {
            this.throwArgumentExpected('11', 'init', 'isReal');
        }

        this._isReal = params.isReal;
    }

    run(gameOptions) {
        if(this._isReal) {
            // after login we need to update the gameInfo inside the gameOptions to get a gameInfo with updated restrictions
            return this.serviceFactory.gamesInformationService().getGamesInfo([gameOptions.gameType])
                .then(gamesInfo => gamesInfo[gameOptions.gameType])
                .then(gameInfo => {
                    if(gameInfo) {
                        Object.assign(gameOptions, {
                            gameInfo: gameInfo
                        });
                    } else {
                        this._showGenericRestrictionMessage();
                        this.logger.warn(`Game type ${gameOptions.gameType} not returned from getGameInfo so show generic restricted message`);
                        throw createGameFlowCancelResponse('Game restricted');
                    }

                    if(gameOptions.gameInfo.restriction.isGameAllowedToPlayReal()) {
                        return gameOptions;
                    } else {
                        this.logger.warn(`Game type ${gameOptions.gameType} is restricted`);
                        gameOptions.gameInfo.restriction.showUserMessage();
                        throw createGameFlowCancelResponse('Game restricted');
                    }
                });
        }

        return Promise.resolve(gameOptions);
    }

    _showGenericRestrictionMessage() {
        return RestrictionMessages.create({
            serviceFactory: this.serviceFactory
        }).showGenericMessage();
    }
}